import { render, staticRenderFns } from "./order-shipment.vue?vue&type=template&id=a8c988e2&scoped=true"
import script from "./order-shipment.vue?vue&type=script&lang=js"
export * from "./order-shipment.vue?vue&type=script&lang=js"
import style0 from "./order-shipment.vue?vue&type=style&index=0&id=a8c988e2&prod&lang=scss&scoped=true"
import style1 from "./order-shipment.vue?vue&type=style&index=1&id=a8c988e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c988e2",
  null
  
)

export default component.exports